import Modal from "react-bootstrap/Modal";
import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import {
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
} from "@mui/material";

import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { TextField } from "@mui/material";

import { Stack, Chip, IconButton } from "@mui/material";
import { Cancel, AddCircleOutline } from "@material-ui/icons";
import { evaluateBService } from "../../../service/manage/evaluate/evaluate_b.service.js";
import { Spinner } from "react-bootstrap";
import {
  sweetErrorAlert,
  sweetStatusAlert,
  sweetSuccessAlert,
} from "../../../components/common/SweetAlert.js";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicator from "@mui/icons-material/DragIndicator";
import SimpleReactValidator from "simple-react-validator";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}
export default class ManageEditFormSetupModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formSetupData: [],
      formSetupDataLoading: false,
      isTitleDataLoading: false,
      selectedTitle: "",
      titles: [],
      formsetups: [],
      items: [],
      choices: [],
      updateDescription: "",
      newItem: "",
      addItemModal: false,
      newChoice: "",
      newWeight: 0,
      isLoading: false,
      submited_forms: "",
    };
    this.createValidationsInstance();
  }

  createValidationsInstance() {
    this.validator = new SimpleReactValidator();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.editFormSetupModal && this.props.editFormSetupModal) {
      this.getAllTitles();
    }
  }

  getAllTitles = () => {
    this.setState({ isTitleDataLoading: true });
    const { mid } = this.props;
    evaluateBService.getAllTitles(mid).then((response) => {
      if (response.success) {
        this.setState({
          titles: response.data.titles,
          isTitleDataLoading: false,
        });
      } else {
        this.setState({ isTitleDataLoading: false });
      }
    });
  };

  handleInputChange = (event, index) => {
    const { name, value } = event.target;
    this.setState((prevState) => {
      const updatedFormsetups = [...prevState.formsetups];
      updatedFormsetups[index] = {
        ...updatedFormsetups[index],
        [name]: value,
      };
      return { formsetups: updatedFormsetups };
    });
  };

  toggleaddItemModal = () => {
    const { addItemModal } = this.state;
    this.setState({
      addItemModal: !addItemModal,
    });
  };

  handleAddCurrentItem = () => {
    if (this.state.newItem.trim() !== "") {
      const newItem = {
        item_id: Date.now(),
        item_name: this.state.newItem,
        item_display_order: this.state.formsetups[0].items.length + 1,
      };

      this.setState((prevState) => {
        const updatedFormsetups = prevState.formsetups.map((form) => {
          if (form.form_id === prevState.selectedTitle.form_id) {
            return {
              ...form,
              items: [...form.items, newItem],
            };
          }
          return form;
        });

        return { formsetups: updatedFormsetups, newItem: "" };
      });
    } else {
      sweetStatusAlert("Warning", "Type the item before you add!", "warning");
    }
  };

  handleInputnewItemChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  getAllFormSetup = async (selectedTitle) => {
    this.setState({ formSetupDataLoading: true });
    const { mid } = this.props;

    try {
      const response = await evaluateBService.getAllFormsetup(
        mid,
        selectedTitle.form_id
      );
      if (response.success) {
        this.setState({
          formsetups: response.data.forms,
          formSetupDataLoading: false,
        });
      } else {
        this.setState({ formSetupDataLoading: false });
      }
    } catch (error) {
      this.setState({ formSetupDataLoading: false });
    }
  };
  getAllSubmited = async (selectedTitle) => {
    this.setState({ formSetupDataLoading: true });
    const { mid } = this.props;

    try {
      const response = await evaluateBService.getallsubForms(
        mid,
        selectedTitle.form_id
      );
      if (response.success) {
        this.setState({
          submited_forms: response.data.sub_forms,
          formSetupDataLoading: false,
        });
      } else {
        this.setState({ formSetupDataLoading: false });
      }
    } catch (error) {
      this.setState({ formSetupDataLoading: false });
    }
  };

  handleItemChange = (itemId, newValue) => {
    this.setState((prevState) => {
      const updatedFormsetups = prevState.formsetups.map((form) => {
        const updatedItems = form.items.map((item) =>
          item.item_id === itemId ? { ...item, item_name: newValue } : item
        );
        return { ...form, items: updatedItems };
      });
      return { formsetups: updatedFormsetups };
    });
  };

  handleRemoveItem = (itemId) => {
    this.setState((prevState) => {
      const updatedFormsetups = prevState.formsetups.map((form) => {
        const updatedItems = form.items.filter(
          (item) => item.item_id !== itemId
        );

        updatedItems.forEach((item, index) => {
          item.item_display_order = index + 1;
        });

        const updatedDeletedItemIds = [
          ...(form.deleted_item_ids || []),
          itemId,
        ];

        return {
          ...form,
          items: updatedItems,
          deleted_item_ids: updatedDeletedItemIds,
        };
      });

      return { formsetups: updatedFormsetups };
    });
  };

  handleSelectTitle = async (event) => {
    const selectedTitle = event.target.value;
    this.setState({ selectedTitle });
    await this.getAllFormSetup(selectedTitle);
    await this.getAllSubmited(selectedTitle);
  };

  closeModel = () => {
    this.setState({ selectedTitle: "", formsetups: [] }, () => {
      this.props.toggleEditFormSetupModal();
    });
  };

  handleInputChoiceChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleInputWeightChange = (e) => {
    let newValue = e.target.value;
    if (newValue < 0) {
      newValue = 0;
    }
    this.setState({ newWeight: newValue });
  };

  handleAddCurrentChoice = () => {
    const newChoice = {
      choice_id: Date.now(),
      choice: this.state.newChoice,
      weight: this.state.newWeight,
      choice_display_order: this.state.formsetups[0].choices.length + 1,
    };

    this.setState((prevState) => {
      const updatedFormsetups = prevState.formsetups.map((form) => {
        if (form.form_id === prevState.selectedTitle.form_id) {
          return {
            ...form,
            choices: [...form.choices, newChoice],
          };
        }
        return form;
      });

      return { formsetups: updatedFormsetups, newChoice: "", newWeight: 0 };
    });
  };

  handleChoiceChange = (choiceId, newValue) => {
    this.setState((prevState) => {
      const updatedFormsetups = prevState.formsetups.map((form) => {
        const updatedChoices = form.choices.map((choice) =>
          choice.choice_id === choiceId
            ? { ...choice, choice: newValue }
            : choice
        );
        return { ...form, choices: updatedChoices };
      });
      return { formsetups: updatedFormsetups };
    });
  };

  handleWeightChange = (choiceId, newWeight) => {
    this.setState((prevState) => {
      const updatedFormsetups = prevState.formsetups.map((form) => {
        const updatedChoices = form.choices.map((choice) =>
          choice.choice_id === choiceId
            ? { ...choice, weight: Number(newWeight) }
            : choice
        );
        return { ...form, choices: updatedChoices };
      });
      return { formsetups: updatedFormsetups };
    });
  };

  handleRemoveChoice = (choiceId) => {
    this.setState((prevState) => {
      const updatedFormsetups = prevState.formsetups.map((form) => {
        const updatedChoices = form.choices.filter(
          (choice) => choice.choice_id !== choiceId
        );

        updatedChoices.forEach((choice, index) => {
          choice.choice_display_order = index + 1;
        });

        const updatedDeletedChoiceIds = [
          ...(form.deleted_choice_ids || []),
          choiceId,
        ];

        return {
          ...form,
          choices: updatedChoices,
          deleted_choice_ids: updatedDeletedChoiceIds,
        };
      });

      return { formsetups: updatedFormsetups };
    });
  };

  handleCheckboxChange = (id) => {
    this.setState((prevState) => ({
      formsetups: prevState.formsetups.map((form) =>
        form.form_id === id
          ? { ...form, show_user: form.show_user === 1 ? 0 : 1 }
          : form
      ),
    }));
  };

  handleUpdate = () => {
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      const { formsetups } = this.state;
      const { mid } = this.props;
      const { selectedTitle } = this.state;

      this.setState({ formSetupDataLoading: true });

      if (formsetups[0]?.items.length === 0) {
        sweetStatusAlert(
          "Warning",
          "At least one item must be added!",
          "warning"
        );
        this.setState({ formSetupDataLoading: false });
        return;
      } else if (formsetups[0]?.choices.length === 0) {
        sweetStatusAlert(
          "Warning",
          "Please add choices before saving.!",
          "warning"
        );
        this.setState({ formSetupDataLoading: false });
        return;
      }

      const object = {
        forms: [
          {
            description: formsetups[0]?.description,
            node_id: mid,
            show_user: formsetups[0]?.show_user,
            items: formsetups[0]?.items,
            choices: formsetups[0]?.choices,
            deleted_item_ids: formsetups[0]?.deleted_item_ids,
            deleted_choice_ids: formsetups[0]?.deleted_choice_ids,
          },
        ],
      };

      evaluateBService
        .updateFormSetup(object, selectedTitle.form_id)
        .then((res) => {
          if (res.success) {
            sweetStatusAlert("Success!", res.message.success, "success");
            this.getAllTitles();
            this.validator.hideMessages();
          } else {
            sweetStatusAlert("Failed!", res.message.error, "error");
          }
        })
        .catch((error) => {
          sweetStatusAlert("Failed!", "Unable to add Form Setup!", "error");
        })
        .finally(() => {
          this.setState({
            formSetupDataLoading: false,
            selectedTitle: "",
          });
        });
    }
  };

  handleChoiceOnDragEnd = (result) => {
    if (!result.destination) return;

    const { formsetups } = this.state;
    const currentForm = formsetups[0];
    const [reorderedChoice] = currentForm.choices.splice(
      result.source.index,
      1
    );
    currentForm.choices.splice(result.destination.index, 0, reorderedChoice);

    currentForm.choices.forEach((choice, index) => {
      choice.choice_display_order = index + 1;
    });

    this.setState({ formsetups: [...formsetups] });
  };

  handleItemDragEnd = (result) => {
    if (!result.destination) return;

    const { formsetups } = this.state;
    const currentForm = formsetups[0];
    const [reorderedItem] = currentForm.items.splice(result.source.index, 1);
    currentForm.items.splice(result.destination.index, 0, reorderedItem);

    currentForm.items.forEach((item, index) => {
      item.item_display_order = index + 1;
    });

    this.setState({ formsetups: [...formsetups] });
  };

  render() {
    const {
      isTitleDataLoading,
      titles,
      selectedTitle,
      formSetupDataLoading,
      newItem,
      addItemModal,
      newChoice,
      newWeight,
    } = this.state;
    return (
      <div>
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.props.editFormSetupModal}
          onHide={() => this.closeModel()}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Form</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "60vh", overflow: "auto" }}>
            <Col md={12}>
              <Form>
                <Row className="mb-3">
                  <Col md={8}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      disabled={isTitleDataLoading}
                    >
                      <InputLabel id="dropdown-title-label">
                        {isTitleDataLoading ? "Loading" : "Select Title"}
                      </InputLabel>
                      <Select
                        labelId="dropdown-title-label"
                        id="dropdown-title"
                        value={selectedTitle?.title}
                        onChange={this.handleSelectTitle}
                        label="Select Title"
                      >
                        {isTitleDataLoading ? (
                          <MenuItem value="">
                            <Box
                              display="flex"
                              justifyContent="center"
                              width="100%"
                            >
                              <CircularProgress size={24} />
                            </Box>
                          </MenuItem>
                        ) : (
                          titles.map((title, index) => (
                            <MenuItem key={index} value={title}>
                              {title.title}
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                <>
                  {formSetupDataLoading ? (
                    <div
                      className="loading-container"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                      </Spinner>
                    </div>
                  ) : (
                    selectedTitle && (
                      <div>
                        {this.state.formsetups?.map((item, index) => (
                          <Row key={index} className="mb-3">
                            <Col md={8}>
                              <TextField
                                label="Description"
                                name="description"
                                multiline
                                rows={4}
                                variant="outlined"
                                value={item.description}
                                onChange={(event) =>
                                  this.handleInputChange(event, index)
                                }
                                style={{ width: "100%", margin: "0 auto" }}
                              />
                              {this.validator.message(
                                "item.description",
                                item.description,
                                "max:1000",
                                {
                                  className: "text-danger",
                                  messages: {
                                    max: "You can only add up to 1000 characters.",
                                  },
                                }
                              )}
                            </Col>
                          </Row>
                        ))}
                        <Row className="mb-3">
                          <Col md={10}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <TextField
                                label="Add New Item"
                                name="newItem"
                                value={newItem}
                                onChange={this.handleInputnewItemChange}
                                variant="outlined"
                                style={{ width: "100%" }}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Enter" &&
                                    this.state.newItem.trim()
                                  ) {
                                    this.handleAddCurrentItem();
                                  }
                                }}
                              />
                              <IconButton
                                color="primary"
                                onClick={this.handleAddCurrentItem}
                                disabled={!this.state.newItem.trim()}
                              >
                                <AddCircleOutline />
                              </IconButton>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <DragDropContext onDragEnd={this.handleItemDragEnd}>
                              <div>
                                {this.state.formsetups.map((form) => (
                                  <Droppable
                                    key={form.form_id}
                                    droppableId={`items-${form.form_id}`}
                                  >
                                    {(provided) => (
                                      <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                      >
                                        {form.items
                                          .sort(
                                            (a, b) =>
                                              a.item_display_order -
                                              b.item_display_order
                                          )
                                          .map((item, index) => (
                                            <Draggable
                                              key={item.item_id}
                                              draggableId={String(item.item_id)}
                                              index={index}
                                            >
                                              {(provided) => (
                                                <Row
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                                  className="mb-2 align-items-center"
                                                  key={item.item_id}
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    padding: "8px",
                                                    marginBottom: "8px",
                                                    backgroundColor: "white",
                                                    borderRadius: "4px",
                                                    boxShadow:
                                                      "0 1px 3px rgba(0, 0, 0, 0.2)",
                                                    ...provided.draggableProps
                                                      .style,
                                                  }}
                                                >
                                                  <Col xs="auto">
                                                    <DragIndicator
                                                      style={{ cursor: "grab" }}
                                                    />
                                                  </Col>
                                                  <Col md={9}>
                                                    <TextField
                                                      value={item.item_name}
                                                      onChange={(e) =>
                                                        this.handleItemChange(
                                                          item.item_id,
                                                          e.target.value
                                                        )
                                                      }
                                                      variant="outlined"
                                                      style={{ width: "100%" }}
                                                    />
                                                  </Col>
                                                  <Col xs="auto">
                                                    <IconButton
                                                      color="secondary"
                                                      onClick={() =>
                                                        this.handleRemoveItem(
                                                          item.item_id
                                                        )
                                                      }
                                                    >
                                                      <Cancel />
                                                    </IconButton>
                                                  </Col>
                                                </Row>
                                              )}
                                            </Draggable>
                                          ))}
                                        {provided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                ))}
                              </div>
                            </DragDropContext>
                          </Col>
                        </Row>
                        {this.state.formsetups.map((form) => (
                          <Row key={form.id} className="mb-3">
                            <Col>
                              <Form.Check
                                type="checkbox"
                                label="Make it anonymous"
                                checked={form.show_user === 1}
                                disabled={
                                  this.state.submited_forms &&
                                  Object.keys(this.state.submited_forms)
                                    .length > 0
                                }
                                onChange={() =>
                                  this.handleCheckboxChange(form.form_id)
                                }
                              />
                            </Col>
                          </Row>
                        ))}
                        <Button
                          className="insert-btn"
                          variant="primary"
                          onClick={this.toggleaddItemModal}
                        >
                          Update choices
                        </Button>
                      </div>
                    )
                  )}
                </>
              </Form>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            {selectedTitle && (
              <Button
                className="insert-btn"
                variant="primary"
                onClick={this.handleUpdate}
                style={{ marginRight: "5px" }}
              >
                Save Changes
              </Button>
            )}
            <Button
              id="modal-close-button"
              style={{ ...this.props.closeBtnStyle, marginLeft: "5px" }}
              onClick={() => this.closeModel()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="md"
          aria-labelledby="contained-modal-subject-vcenter"
          centered
          show={addItemModal}
          onHide={this.toggleaddItemModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Choices</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form>
              <Row className="my-4">
                <Form.Group
                  as={Col}
                  md="12"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Choice*</Form.Label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <TextField
                      label="Add Choices"
                      name="newChoice"
                      value={newChoice}
                      onChange={this.handleInputChoiceChange}
                      variant="outlined"
                      style={{ flex: 2 }}
                    />
                    <TextField
                      label="Add Weight"
                      name="newWeight"
                      value={newWeight}
                      onChange={this.handleInputWeightChange}
                      variant="outlined"
                      style={{ flex: 1 }}
                      type="number"
                    />
                    <IconButton
                      color="primary"
                      onClick={this.handleAddCurrentChoice}
                      disabled={!this.state.newChoice.trim()}
                    >
                      <AddCircleOutline />
                    </IconButton>
                  </div>
                  <div className="mt-4">
                    <DragDropContext onDragEnd={this.handleChoiceOnDragEnd}>
                      {this.state.formsetups?.map((form) => (
                        <Droppable
                          key={form.form_id}
                          droppableId={`choices-${form.form_id}`}
                        >
                          {(provided) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {form.choices
                                .sort(
                                  (a, b) =>
                                    a.choice_display_order -
                                    b.choice_display_order
                                )
                                .map((choice, index) => (
                                  <Draggable
                                    key={choice.choice_id}
                                    draggableId={String(choice.choice_id)}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "8px",
                                          marginBottom: "8px",
                                          backgroundColor: "white",
                                          borderRadius: "4px",
                                          boxShadow:
                                            "0 1px 3px rgba(0, 0, 0, 0.2)",
                                          ...provided.draggableProps.style,
                                        }}
                                      >
                                        <Col xs="auto">
                                          <DragIndicator
                                            style={{ cursor: "grab" }}
                                          />
                                        </Col>
                                        <TextField
                                          value={choice.choice}
                                          onChange={(e) =>
                                            this.handleChoiceChange(
                                              choice.choice_id,
                                              e.target.value
                                            )
                                          }
                                          variant="outlined"
                                          style={{
                                            flex: 2,
                                            marginRight: "8px",
                                          }}
                                        />
                                        <TextField
                                          value={choice.weight}
                                          onChange={(e) =>
                                            this.handleWeightChange(
                                              choice.choice_id,
                                              e.target.value
                                            )
                                          }
                                          variant="outlined"
                                          type="number"
                                          style={{ flex: 1 }}
                                        />
                                        <IconButton
                                          color="secondary"
                                          onClick={() =>
                                            this.handleRemoveChoice(
                                              choice.choice_id
                                            )
                                          }
                                        >
                                          <Cancel />
                                        </IconButton>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      ))}
                    </DragDropContext>
                  </div>
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button
              sx={{ mr: "20px" }}
              onClick={this.toggleaddItemModal}
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
